import { render, staticRenderFns } from "./IconSvgAvi.vue?vue&type=template&id=4638331c&scoped=true&"
import script from "./IconSvgAvi.vue?vue&type=script&lang=js&"
export * from "./IconSvgAvi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638331c",
  null
  
)

export default component.exports